(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["filtruotas-home"] && !Shopify.designMode) return;
  try {
    
class FiltruotasCartridgeFinder extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';

    this.form = this.querySelector('[data-finder-form]');
    this.input = this.querySelector('[data-finder-input]');
    this.message = this.querySelector('[data-finder-message]');
    this.results = this.querySelector('[data-finder-results]');
    const indexElement = this.querySelector('[data-finder-index]');

    try {
      this.products = JSON.parse(indexElement?.textContent || '[]').map((product) => ({
        ...product,
        models: Array.isArray(product.models) ? product.models : [],
      }));
    } catch (_error) {
      this.products = [];
    }

    this.form?.addEventListener('submit', (event) => {
      event.preventDefault();
      this.search();
    });
  }

  normalizeModel(value) {
    return String(value || '').trim().toUpperCase().replace(/[^A-Z0-9]/g, '');
  }

  search() {
    const model = this.normalizeModel(this.input?.value);
    this.results.replaceChildren();
    this.message.replaceChildren();

    if (!model) {
      this.addMessage('Įveskite filtro modelį.');
      this.input?.focus();
      return;
    }

    const matches = this.products.filter((product) =>
      product.models.some((compatibleModel) => this.normalizeModel(compatibleModel) === model)
    );

    if (!matches.length) {
      this.addMessage('Pagal šį modelį kasetės neradome.');
      this.addMessage('Patikrinkite modelio kodą arba susisiekite su mumis – padėsime nustatyti tinkamą kasetę.');
      return;
    }

    this.addMessage(`Rasta tinkamų kasečių: ${matches.length}.`);
    const fragment = document.createDocumentFragment();
    matches.forEach((product) => fragment.append(this.createProductCard(product)));
    this.results.append(fragment);
  }

  addMessage(text) {
    const paragraph = document.createElement('p');
    paragraph.textContent = text;
    this.message.append(paragraph);
  }

  createProductCard(product) {
    const card = document.createElement('a');
    card.className = 'finder-product';
    card.href = product.url;

    const media = document.createElement('span');
    media.className = 'finder-product__media';
    if (product.image) {
      const image = document.createElement('img');
      image.src = product.image;
      image.alt = product.imageAlt || product.title;
      image.loading = 'lazy';
      image.width = 720;
      image.height = 540;
      media.append(image);
    }

    const body = document.createElement('span');
    body.className = 'finder-product__body';
    const title = document.createElement('h3');
    title.textContent = product.title;
    body.append(title);

    if (product.showPrice && product.price) {
      const price = document.createElement('p');
      price.className = 'finder-product__price';
      price.textContent = product.price;
      body.append(price);
    }

    const cta = document.createElement('span');
    cta.className = 'finder-product__cta';
    cta.textContent = 'Peržiūrėti →';
    body.append(cta);
    card.append(media, body);
    return card;
  }
}

if (!customElements.get('cartridge-finder')) {
  customElements.define('cartridge-finder', FiltruotasCartridgeFinder);
}

class FiltruotasFaqAccordion extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';
    this.addEventListener('click', (event) => {
      const trigger = event.target.closest('.faq__trigger');
      if (!trigger || !this.contains(trigger)) return;

      const shouldOpen = trigger.getAttribute('aria-expanded') !== 'true';
      this.querySelectorAll('.faq__trigger').forEach((button) => {
        const panel = document.getElementById(button.getAttribute('aria-controls'));
        const isCurrent = button === trigger;
        const expanded = isCurrent && shouldOpen;
        button.setAttribute('aria-expanded', String(expanded));
        if (panel) panel.hidden = !expanded;
      });
    });
  }
}

if (!customElements.get('faq-accordion')) {
  customElements.define('faq-accordion', FiltruotasFaqAccordion);
}

  } catch(e) { console.error(e); }
})();
})();
